import { AppDispatch, RootState } from '..';
import { onAddingCompanyRegistartionRequests, onCompanyRegistartionRequestsUpdate, onDeleteCompanyRegistartionRequests, setCompanyRegistartionRequests } from '../reducers';

import { REACT_APP_MANAGE_SERVICE_ENDPOINT } from '../types';
import axios from 'axios';
import { headers } from '.';
import { notification } from '../../utils';
import { requestCompanyRegistration } from '../../types';

export const getCompanyRegistrationRequest = () => async (dispatch: AppDispatch, getState: RootState) => {

    const { company } = getState().companyReducer;
    const { token } = getState().authReducer;

    const { company_id } = company;

    const { data } = await axios.get(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/company-register-request/${company_id}`, headers(token));

    const { requests } = data;

    try {

        dispatch(setCompanyRegistartionRequests(requests));
        
    } catch (error: any) {
        console.log(error.message);
    }
};

export const addCompanyRegistrationRequest = (request: requestCompanyRegistration) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onAddingCompanyRegistartionRequests(true));

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;
    const { company_id } = company;

    const { data } = await axios.post(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/company-register-request/add`, {...request, company_id}, headers(token));

    try {

        const { success, message } = data;
        notification(success ? 'success' : 'error', message);
        dispatch(onAddingCompanyRegistartionRequests(false));
        
    } catch (error: any) {
        notification('error', error.message);
        dispatch(onAddingCompanyRegistartionRequests(false));
    }
};

export const updateCompanyRegistrationRequest = (request: requestCompanyRegistration) => async (dispatch: AppDispatch, getState: RootState) => {
    
    dispatch(onCompanyRegistartionRequestsUpdate(true));
    
    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/company-register-request/update`, { ...request }, headers(token));

    try {

        const { success, message } = data;
        notification(success ? 'success' : 'error', message);
        dispatch(onCompanyRegistartionRequestsUpdate(false));
        
    } catch (error: any) {
        notification('error', error.message);
        dispatch(onCompanyRegistartionRequestsUpdate(false));
    }
};

export const deleteCompanyRegistrationRequest = (request_id: string) => async (dispatch: AppDispatch, getState: RootState) => {
    
    dispatch(onDeleteCompanyRegistartionRequests(true));
    
    const { token } = getState().authReducer;

    const { data } = await axios.delete(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/company-register-request/${request_id}/delete`, headers(token));

    try {

        const { success, message } = data;
        notification(success ? 'success' : 'error', message);
        dispatch(onDeleteCompanyRegistartionRequests(false));
        
    } catch (error: any) {
        notification('error', error.message);
        dispatch(onDeleteCompanyRegistartionRequests(false));
    }
};